import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import rootReducer from 'redux/ducks/index';
import SagaManager from 'redux/sagas/SagaManager';

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: rootReducer,
  middleware: [sagaMiddleware],
  devTools: process.env.NODE_ENV !== 'production',
  preloadedState: undefined,
});

SagaManager.startSagas(sagaMiddleware);

if (module.hot) {
  module.hot.accept('redux/ducks', () => store.replaceReducer(require('redux/ducks').default));
  module.hot.accept('redux/sagas/SagaManager', () => {
    SagaManager.cancelSagas(store);
    require('redux/sagas/SagaManager').default.startSagas(sagaMiddleware);
  });
}

export default store;
